export class Deposit {
  type: string;
  currency: string;
  amount: number;
  rate: number;
  fee: number;
  partner_id: string;
  branch_code: string;
  fee_force: boolean = false;
  partner_name: string;
  branch_name: string;
  deposit_account_name: string;
  deposit_type: string;

  static CloneForCreateTranaction(deposit: Deposit, validation?: boolean) {
    const clone = new Deposit();
    clone.partner_id = deposit.partner_id;
    clone.amount = deposit.amount;
    clone.fee = deposit.fee;
    if (!validation) {
      clone.branch_code = deposit.branch_code;
      clone.currency = deposit.currency;
      clone.deposit_account_name = deposit.deposit_account_name;
      clone.deposit_type = deposit.deposit_type;
      clone.rate = deposit.rate;
    }
    return clone;
  }
}

export const Bank = {
  '002': 'KDB산업은행',
  '003': 'IBK기업은행',
  '004': 'KB국민은행',
  '006': 'KB국민은행(구 주택은행)',
  '007': '수협중앙회',
  '011': 'NH농협은행',
  '012': '농협은행(단위농협)',
  '020': '우리은행',
  '023': 'SC제일은행',
  '031': '대구은행',
  '032': '부산은행',
  '034': '광주은행',
  '035': '제주은행',
  '037': '전북은행',
  '039': '경남은행',
  '045': '새마을금고',
  '050': '상호저축은행',
  '081': 'KEB하나은행',
  '088': '신한은행'
};

export const VoucherBank = {
  '002': 'Development(KDB)',
  '003': 'Industrial(IBK)',
  '004': 'Kookmin',
  '006': 'Kookmin',
  '007': 'Suhyup',
  '011': 'Nonghyup',
  '012': 'Nonghyup',
  '020': 'Woori',
  '023': 'SC',
  '027': 'Citi',
  '031': 'Daegu',
  '032': 'Busan',
  '034': 'Kwangju',
  '035': 'Jeju',
  '037': 'Jeonbuk',
  '039': 'Kyongnam',
  '045': 'KFCC',
  '050': 'FSB',
  '081': 'KEB Hana',
  '088': 'Shinhan'
};



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/deposit.ts